package com.karyadina.cloudsync.service

import com.karyadina.cloudsync.model.NetworkPreference

/**
 * Minimal Web background sync service
 */
class WebBackgroundSyncService : IBackgroundSyncService {
    
    private var currentIntervalMinutes = 0
    
    override suspend fun schedulePeriodicSync(
        intervalMinutes: Int,
        networkPreference: NetworkPreference
    ): Result<Unit> {
        currentIntervalMinutes = intervalMinutes
        return Result.success(Unit)
    }
    
    override suspend fun cancelPeriodicSync(): Result<Unit> {
        currentIntervalMinutes = 0
        return Result.success(Unit)
    }
    
    override fun isPeriodicSyncScheduled(): Boolean {
        return currentIntervalMinutes > 0
    }
    
    override fun getSyncInterval(): Int {
        return currentIntervalMinutes
    }
    
    override suspend fun queueSync(): Result<Unit> {
        return Result.success(Unit)
    }
    
    override suspend fun processPendingQueue(): Result<Unit> {
        return Result.success(Unit)
    }
}
